/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import {
    DropdownSelectField, CurrencyValue, Loader,
    useModal as ModalShow,
} from '@jutro/components';
import { IntlContext, TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import styles from './ClauseComponent.module.scss';
import messages from './ClauseComponentVM.messages';
import CoveragesPopUp from '../BasicQuote/QuoteCoveragesPopover/CoveragesPopUp';


class ClauseComponent extends Component {
    /**
     * @memberof gw-components-platform-react.ClauseComponent
     * @prop {Object} propTypes - the props that are passed to this component
     * @prop {string} propTypes.displayName - name of clause to display
     * @prop {bool} propTypes.readOnly - if the clause selection is read only
     * @prop {bool} propTypes.value - is the clause is seleceted
     * @prop {function} propTypes.onValueChange - callback when change is made
     * @prop {string} propTypes.path - path to value in the view modal
     * @prop {bool} propTypes.isLoading - should the clause be loading
     * @prop {string} propTypes.loadingMessage - message to be shown while loading
     * @prop {string} propTypes.containerClassName - clause container class
     * @prop {bool} propTypes.showAmount - determine to show amount next to displayName
     */

    static contextType = IntlContext;

    static contextType = TranslatorContext;

    static propTypes = {
        id: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
        readOnly: PropTypes.bool,
        onValueChange: PropTypes.func.isRequired,
        children: PropTypes.arrayOf(PropTypes.shape({})),
        value: PropTypes.bool,
        path: PropTypes.string,
        isLoading: PropTypes.bool,
        loadingMessage: PropTypes.string,
        checked: PropTypes.bool,
        isEditable: PropTypes.bool,
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        containerClassName: PropTypes.string,
        amount: PropTypes.arrayOf(PropTypes.shape({})),
        showAmount: PropTypes.bool,
        hasTerms: PropTypes.bool,
        publicID: PropTypes.string.isRequired,
        showError: PropTypes.bool,
        showModal: PropTypes.any
    };

    static defaultProps = {
        readOnly: false,
        path: undefined,
        value: undefined,
        isLoading: false,
        loadingMessage: '',
        checked: false,
        children: undefined,
        isEditable: true,
        description: undefined,
        containerClassName: undefined,
        amount: undefined,
        showAmount: true,
        hasTerms: false,
        showError: false
    };

    getLabelNameWithAmount = (labelName, labelAmount) => {
        const { showAmount } = this.props;

        if (!_.isUndefined(labelAmount) && showAmount) {
            const intl = this.context;
            const formatterCurrency = intl.formatNumber(
                labelAmount.amount,
                {
                    style: 'currency',
                    currency: labelAmount.currency,
                    currencyDisplay: 'code'
                }
            );
            return `${labelName} ${formatterCurrency}`;
        }
        return labelName;
    };

    getAdditionalLabel(displayName, publicID, columnData) {
        if (publicID === 'PAUninsuredMotoristCommon_alfa') {
            return 'Uninsured Motorist - Reduced or Added On';
        }

        return '';
    }

    getUpdatedLabel(displayName, publicID, columnData) {
        if (publicID === 'PAUninsuredMotoristCommon_alfa') {
            return 'Uninsured Motorist - Deductible';
        }
        return displayName;
    }


    getCommonTerm(displayName, publicID, columnData, value,
        children, amount, termValue, convertedAmount, emptyValue,
        showError, errorMessages, additionalLabel) {
        const label = additionalLabel
            ? this.getAdditionalLabel(
                displayName,
                publicID,
                columnData
            )
            : this.getUpdatedLabel(
                displayName,
                publicID,
                columnData
            );
        const devicePhone = BreakpointTrackerContext._currentValue === 'phone';
        if (devicePhone) {
            return (
                <React.Fragment>
                    <div>
                        <span>
                            <p className={styles.headerStyle}>{label}</p>
                        </span>
                    </div>
                    <div className={styles.paClauseGrid}>
                        {
                            <span id={publicID} className={styles.paClauseGridSlotLeft}>
                                {children}
                            </span>
                        }

                        {amount !== undefined && termValue !== 'Not Included' ? (
                            <span className={styles.mobileAmount}>
                                {convertedAmount}
                            </span>
                        ) : (
                            <span className={styles.mobileAmount}>{emptyValue}</span>
                        )}
                        <span
                            className={styles.mobileLearnMore}
                            id={publicID}
                            onClick={(e) => this.openModal(publicID, value, children, label, e)}
                        >
Learn More
                        </span>
                    </div>
                    {showError ? (
                        <span className={styles.quoteError}>
                            <i className="fa fa-exclamation-circle" />
                            {' '}
                            {errorMessages}
                        </span>
                    ) : null}
                    <hr className={styles.divider} />
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <div>
                    <div>
                        <span>
                            <p className={styles.headerStyle}>
                                { label }
                            </p>
                        </span>
                    </div>
                    <div className={styles.paClauseGrid}>
                        {(
                            <span id={publicID} className={styles.paClauseGridSlotLeft}>
                                {children}
                            </span>
                        )}

                        {amount !== undefined && termValue !== 'Not Included' ? (
                            <span className={styles.paClauseGridSlotMiddle}>
                                {convertedAmount}
                            </span>
                        ) : (
                            <span className={styles.paClauseGridSlotMiddle}>
                                {emptyValue}
                            </span>
                        )}
                        <span
                            id={publicID}
                            onClick={(e) => this.openModal(publicID, value, children, label, e)}
                            className={styles.paClauseGridSlotRight}
                        >
Learn More
                        </span>
                    </div>
                </div>
                {showError ? (
                    <span className={styles.quoteError}>
                        <i className="fa fa-exclamation-circle" />
                        {' '}
                        {errorMessages}
                    </span>
                ) : null}
                <hr className={styles.divider} />
            </React.Fragment>
        );
    }

    getCommonTerms(displayName, publicID, columnData, value,
        children, amount, termValue, convertedAmount, emptyValue, showError, errorMessages) {
        const childrenAddOn = [...children];
        childrenAddOn[0] = {
          ...children[0],
          props: {
            ...children[0].props,
            children: {
              ...children[0].props.children,
              props: {
                ...children[0].props.children.props,
                children: [...children[0].props.children.props.children],
              },
            },
          },
        };
        childrenAddOn[0].props.children.props.children[1] = undefined;

        const childrenDed = [...children];
        childrenDed[0] = {
          ...children[0],
          props: {
            ...children[0].props,
            children: {
              ...children[0].props.children,
              props: {
                ...children[0].props.children.props,
                children: [...children[0].props.children.props.children],
              },
            },
          },
        };
        childrenDed[0].props.children.props.children[0] = undefined;

        return (
            <React.Fragment>
                <div>
                    {
                        this.getCommonTerm(
                            displayName, publicID,
                            columnData, value,
                            childrenAddOn, amount, termValue, convertedAmount,
                            emptyValue, showError, errorMessages, true
                        )
                    }
                </div>
                <div>
                    {
                        this.getCommonTerm(
                            displayName, publicID,
                            columnData, value,
                            childrenDed, amount, termValue, convertedAmount,
                            emptyValue, showError, errorMessages, false
                        )
                    }
                </div>
            </React.Fragment>
        );
    }

    handleChange = (value) => {
        const { onValueChange, path } = this.props;

        if (onValueChange) {
            onValueChange(value, path);
        }
    };

    subHeader(publicID, columnData) {
        let subHeader;
        for (const data of columnData) {
            if (data && (publicID === 'PABI_alfa' || publicID === 'PAUninsuredMotoristBI_alfa')) {
                subHeader = 'Each Person / Each Accident';
            } else if (data && (publicID === 'PAPropertyDamage_alfa' || publicID === 'PAUninsuredMotoristPD_alfa')) {
                subHeader = 'Each Accident';
            } else if (data && publicID === 'PAMedicalPayments_alfa') {
                subHeader = 'Each Person';
            } else {
                subHeader = '';
            }
        }
        return subHeader;
    }

    openModal(publicID, value, children, label, e) {
        const { showModal } = this.props;
        let modalValue;
        if (!_.isNil(children)) {
            modalValue = e.target
                .closest('div')
                .querySelector('.jut__GenericSelectControl__control')
                .querySelector('div')
                .textContent.trim();
        } else {
            modalValue = value ? 'Included' : 'Not Included';
        }
        
        const data = { modalId: publicID, value: modalValue, name: label };
        return showModal(<CoveragesPopUp {...data}/>);
    }

    isCommonTerms(publicID, columnData) {
    if (publicID !== "PAUninsuredMotoristCommon_alfa") {
      return false;
    }

    return columnData.some((data) => data && data.code === "PABasicGA");
}

    renderEditableValue() {
        const {
            displayName,
            readOnly,
            value,
            id,
            isLoading,
            loadingMessage,
            children,
            path,
            checked,
            hasTerms,
            description,
            containerClassName,
            amount,
            publicID,
            showError,
            columnData
        } = this.props;
        const devicePhone = BreakpointTrackerContext._currentValue === 'phone';
        const hasChildren = !_.isNil(children);
        const clauseContainerStyles = classNames(styles.clause, containerClassName);
        /**
         * const checkboxControlStyles = classNames({
            [styles.clauseAndTermSpacing]: hasChildren
        });
        const checkboxStyles = classNames({
            [styles.clauseNoPadding]: !hasChildren
        });
        **/
        const translator = this.context;

        const termValue = value ? 'Included' : '$0.00';
        const emptyValue = publicID === 'PAAccidentWaiver_alfa' ? termValue : '$0.00';
        const messagePath = 'policycommon.directives.coverages.';
        const message = `${messagePath}${publicID}`;
        const displayAmount = termValue === 'Not Included' ? emptyValue : amount;
        const errorMessages = translator(_.find(messages, { id: message }));

        const showDropDown = ['PAAccidentWaiver_alfa', 'PAADD_alfa', 'PATowingLaborCov', 'PALeaseLoan_alfa', 'PALossOfIncome_alfa'];
        const hasDropDown = showDropDown.indexOf(publicID) !== -1;
        let convertedAmount = '';
        if (amount !== undefined) {
            const amtString = `$${amount.amount}`;
            const decimalPoint = amtString.split('.')[1];
            if (_.isEmpty(decimalPoint)) {
                convertedAmount = `${amtString}.00`;
            } else if (!_.isEmpty(decimalPoint) && decimalPoint.length === 1) {
                convertedAmount = `${amtString}0`;
            } else {
                convertedAmount = `${amtString}`;
            }
        }

        return (
            <div className={clauseContainerStyles}>
                {isLoading ? (
                    <Loader loaded={!isLoading} text={loadingMessage} />
                ) : (
                    <div>
                        {!devicePhone ? (
                            this.isCommonTerms(publicID, columnData) ? (
                                this.getCommonTerms(displayName, publicID, columnData, value,
                                    children, amount, termValue, convertedAmount,
                                    emptyValue, showError, errorMessages)
                            ) : (
                                <div>
                                    <div>
                                        <div>
                                            <span>
                                                <p  className={
                                                    this.getUpdatedLabel(displayName, publicID, columnData) === 'Accident Waiver'
                                                    ? styles.headerStyleAccident
                                                    : styles.headerStyle
                                                }>
                                                    {this.getUpdatedLabel(
                                                        displayName,
                                                        // eslint-disable-next-line indent
                                                    publicID,
                                                        columnData
                                                    )}
                                                </p>
                                                <span className={styles.subHeader}>{this.subHeader(publicID, columnData)}</span>
                                            </span>
                                        </div>
                                        <div className={styles.paClauseGrid}>
                                            {hasDropDown ? (
                                                <span className={styles.paClauseGridSlotLeft}>
                                                    <DropdownSelectField
                                                        autoTrim={false}
                                                        availableValues={[
                                                            {
                                                                displayName: {
                                                                    defaultMessage: 'Included',
                                                                    id: 'policycommon.directives.coverages.Included',
                                                                },
                                                                id: 'true',
                                                            },
                                                            {
                                                                displayName: {
                                                                    defaultMessage: 'Not Included',
                                                                    id: 'policycommon.directives.coverages.Not Included',
                                                                },
                                                                id: 'false',
                                                            },
                                                        ]}
                                                        path={path}
                                                        disabled={false}
                                                        hideLabel
                                                        id={id}
                                                        value={value}
                                                        onValueChange={this.handleChange}
                                                        className={styles.clause_term}
                                                        readOnly={false}
                                                        required={false}
                                                        schemaRequired={false}
                                                        searchable={false}
                                                        showErrors={false}
                                                        showValidationIcon={false}
                                                    />
                                                </span>
                                            ) : null}
                                            {!hasDropDown ? (
                                                <span
                                                    id={publicID}
                                                    className={styles.paClauseGridSlotLeft}
                                                >
                                                    {children}
                                                </span>
                                            ) : null}

                                            {amount !== undefined && termValue !== 'Not Included' ? (
                                                <span className={styles.paClauseGridSlotMiddle}>
                                                    {convertedAmount}
                                                </span>
                                            ) : (
                                                <span className={styles.paClauseGridSlotMiddle}>
                                                    {emptyValue}
                                                </span>
                                            )}
                                            <span
                                                id={publicID}
                                                onClick={(e) => this.openModal(publicID, value, children, this.getUpdatedLabel(displayName, publicID, columnData), e)}
                                                className={styles.paClauseGridSlotRight}
                                            >
Learn More
                                            </span>
                                        </div>
                                    </div>
                                    {showError ? (
                                        <span className={styles.quoteError}>
                                            <i className="fa fa-exclamation-circle" />
                                            {' '}
                                            {errorMessages}
                                        </span>
                                    ) : null}
                                    <hr className={styles.divider} />
                                </div>
                            )
                        )
                            : this.isCommonTerms(publicID, columnData) ? (
                                this.getCommonTerms(displayName, publicID, columnData, value,
                                    children, amount, termValue, convertedAmount,
                                    emptyValue, showError, errorMessages)
                            )
                                : (
                                    <div>
                                        <div>
                                            <span>
                                               <p  className={
                                                    this.getUpdatedLabel(displayName, publicID, columnData) === 'Accident Waiver'
                                                    ? styles.headerStyleAccident
                                                    : styles.headerStyle
                                                }>
                                                    {this.getUpdatedLabel(displayName, publicID, columnData)}
                                                </p>
                                                <span className={styles.subHeader}>{this.subHeader(publicID, columnData)}</span>
                                            </span>
                                        </div>
                                        <div className={styles.paClauseGrid}>
                                            {hasDropDown ? (
                                                <span className={styles.paClauseGridSlotLeft}>
                                                    <DropdownSelectField
                                                        autoTrim={false}
                                                        availableValues={[
                                                            {
                                                                displayName: {
                                                                    defaultMessage: 'Included',
                                                                    id: 'policycommon.directives.coverages.Included',
                                                                },
                                                                id: 'true',
                                                            },
                                                            {
                                                                displayName: {
                                                                    defaultMessage: 'Not Included',
                                                                    id: 'policycommon.directives.coverages.Not Included',
                                                                },
                                                                id: 'false',
                                                            },
                                                        ]}
                                                        path={path}
                                                        disabled={false}
                                                        hideLabel
                                                        id={id}
                                                        value={value}
                                                        onValueChange={this.handleChange}
                                                        className={styles.clause_term}
                                                        readOnly={false}
                                                        required={false}
                                                        schemaRequired={false}
                                                        searchable={false}
                                                        showErrors={false}
                                                        showValidationIcon={false}
                                                    />
                                                </span>
                                            ) : null}
                                            {!hasDropDown ? (
                                                <span className={styles.paClauseGridSlotLeft}>
                                                    {children}
                                                </span>
                                            ) : null}

                                            {amount !== undefined && termValue !== 'Not Included' ? (
                                                <span className={styles.mobileAmount}>
                                                    {convertedAmount}
                                                </span>
                                            ) : (
                                                <span className={styles.mobileAmount}>{emptyValue}</span>
                                            )}
                                            <span
                                                className={styles.mobileLearnMore}
                                                id={publicID}
                                                onClick={(e) => this.openModal(publicID, value, children, this.getUpdatedLabel(displayName, publicID, columnData), e)}
                                            >
                                        Learn More
                                            </span>
                                        </div>
                                        {showError ? (
                                            <span className={styles.quoteError}>
                                                <i className="fa fa-exclamation-circle" />
                                                {errorMessages}
                                            </span>
                                        ) : null}
                                        <hr className={styles.divider} />
                                    </div>
                                )}
                    </div>
                )}
            </div>
        );
    }

    renderReadOnlyValue() {
        const { displayName, children, amount } = this.props;

        return (
            <div className={styles.readOnlyGrid}>
                <span className={styles.readOnlyGridSlotLeft}>
                    {displayName}
                    <span className={styles.readOnlyGridAmount}>
                        {!_.isUndefined(amount) ? (
                            <CurrencyValue
                                amount={amount.amount}
                                currency={amount.currency}
                                showFractions
                            />
                        ) : undefined}
                    </span>
                </span>
                <div className={styles.readOnlyGridSlotRight}>{children}</div>
            </div>
        );
    }

    render() {
        const { isEditable } = this.props;
        return isEditable ? this.renderEditableValue() : this.renderReadOnlyValue();
    }
}
export default ClauseComponent;
